import React from 'react';

import CheckboxFilter from 'bundles/backoffice/filters/checkbox';

import type { Filters } from './types';

export const options = [
  { label: 'Call', value: 'call' },
  { label: 'Meeting', value: 'meeting' },
  { label: 'Tour', value: 'showing' },
  { label: 'Note', value: 'note' },
  { label: 'Email', value: 'message' },
];

type Slice = Pick<Filters, 'activityTypes'>;
interface Props extends Slice {
  onChange: (changes: Slice) => void;
}

export default function ActivityTypeFilter({ activityTypes, onChange }: Props) {
  return (
    <CheckboxFilter
      addFilter={(_name, filter) => onChange({ activityTypes: [...(activityTypes), filter] })}
      className="ml-0"
      hideClearControl={!activityTypes?.length}
      hideSelectedCount={!activityTypes?.length}
      label="Type"
      options={options}
      removeFilter={(_name, filter) => onChange({ activityTypes: (activityTypes).filter(t => t !== filter) })}
      selected={activityTypes}
      onClear={() => onChange({ activityTypes: [] })}
    />
  );
}
